import { boot } from 'quasar/wrappers';
import { createI18n } from 'vue-i18n';
import messages from '@i18n';

export const i18nInstance = createI18n({
  legacy: false,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages,
});

export const i18n = i18nInstance.global;

export default boot(({ app }) => {
  // Set i18n instance on app
  app.use(i18nInstance);
});
